import {
  Combobox,
  useCombobox,
  Text,
  Button,
  useMantineColorScheme,
} from "@mantine/core"
import { IconChevronDown } from "@tabler/icons-react"
import { useSuspenseQueryGet } from "../../../../../typed-client/hooks/use-suspense-query-get"
import { useTranslation } from "react-i18next"
import { DateOnly } from "../../../../../@client/System"

export function ProductionSelect({
  value: selectedValue,
  onChange,
  start,
  end,
  departmentId,
}: {
  value: number | null
  onChange: (v: number | null) => void
  start: DateOnly
  end: DateOnly
  departmentId: number
}) {
  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
  })

  const { data } = useSuspenseQueryGet(
    "/api/Production/GetProductionsInPeriodWithDepartmentCollectiveBasicCast",
    {
      start,
      end,
      departmentId,
      includeProductionId: selectedValue,
    }
  )

  const selectedItem = selectedValue
    ? (data.find((v) => v.productionId === selectedValue) ?? null)
    : null

  const options = data.map((item) => (
    <Combobox.Option
      value={item.productionId.toString()}
      key={item.productionId}
    >
      {item.title}
    </Combobox.Option>
  ))
  const { colorScheme } = useMantineColorScheme()
  const { t } = useTranslation("app_server")
  return (
    <Combobox
      store={combobox}
      width={250}
      position="bottom-start"
      withArrow
      onOptionSubmit={(val) => {
        if (val === null || val === "_all") {
          onChange(null)
        } else {
          onChange(parseInt(val))
        }
        combobox.closeDropdown()
      }}
    >
      <Combobox.Target>
        <Button
          px={0}
          variant="subtle"
          color={colorScheme === "dark" ? "gray.0" : "dark.8"}
          style={{
            border: "none",
            background: "none",
          }}
          onClick={() => {
            combobox.openDropdown()
          }}
          rightSection={
            <IconChevronDown
              color={
                selectedItem == null ? "var(--mantine-color-dimmed)" : undefined
              }
              size={14}
            />
          }
        >
          {selectedItem ? (
            <Text fw={500} size="xl">
              {selectedItem?.title || "Nothing selected"}
            </Text>
          ) : (
            <Text c="dimmed" size="xl">
              Produktion
            </Text>
          )}
        </Button>
      </Combobox.Target>

      <Combobox.Dropdown>
        <Combobox.Options mah={400} style={{ overflowY: "auto" }}>
          <Combobox.Option value={"_all"} key="_all">
            {t("ShowAllProductions")}
          </Combobox.Option>
          {options}
        </Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  )
}
